import amplitude from "amplitude-js";
import { getSession } from "@/utils/trpc";

const AMPLITUDE_API_KEY = process.env.NEXT_PUBLIC_AMPLITUDE_API_KEY;
let analyticsClient: amplitude.AmplitudeClient;

export function getOrCreateAnalyticsClient() {
  const auth = getSession();
  if (!AMPLITUDE_API_KEY || !auth) {
    return null;
  }
  if (!analyticsClient) {
    analyticsClient = amplitude.getInstance();
    analyticsClient.init(AMPLITUDE_API_KEY, encodeURIComponent(auth.email), {
      includeUtm: true,
    });
  }
  return analyticsClient;
}

export function trackEvent(
  eventName: string,
  eventProperties: { [key: string]: string | number | boolean } = {}
) {
  if (typeof window === "undefined") {
    return;
  }

  getOrCreateAnalyticsClient()?.logEvent(eventName, eventProperties);
}

export const EVENTS = {
  SESSION_STARTED: "[Peasy Demo] Started Session",
  NEW_CHAT: "[Peasy Demo] New Chat Started",
  MESSAGE_SENT: "[Peasy Demo] Message Sent",
  GRAMMAR_OPENED: "[Peasy Demo] Grammar review Modal Opened",
  SUGGESTION_CLICKED: "[Peasy Demo] Suggestions Used",
  TRANSLATION_OPENED: "[Peasy Demo] Translation Modal Opened",
  WORD_OPENED: "[Peasy Demo] Word Modal Opened",
  MESSAGE_FAILED: "[Peasy Demo] Message Failed to Send",
  PAYWALL: "[Peasy Demo] Message limit reached",
  DOWNLOAD_PDF: "[Peasy Demo] PDF Downloaded",
};
